import React, { Component } from 'react';
import HeaderNav from './common/HeaderNav';
import './styles/Number.css'
import { Link } from 'react-router-dom';
// import SideFilterBar from './common/SideFilterBar';
//  search field
import TextField from '@mui/material/TextField';
//   search button
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { Button } from '@mui/material';
import queryString from 'query-string';
import apiCall from '../utils/apiCall';
import NumberBox from './common/NumberBox';
import styledComponents from './styles/styledComponents';
import Model from './common/Model';
import { connect } from "react-redux";
import { cartInfo } from './common/redux/actions';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
//  import Box from '@mui/material/Box';
//  import Modal from '@mui/material/Modal';

let mountLimit = 1;
let retryLimit = 1;

const {
  IconWhiteHover,
  Form,
  ButtonWrapper,
  ButtonSecondary,
  ButtonSuccess,
  Title,
  SubHeading
} = styledComponents;

class OrderStatus extends Component {
  state = {
    paymentInfo: {},
    getStatus: false,
  }


  async componentDidMount(filterData = null) {
    if (mountLimit == 1 || retryLimit == 2) {
      mountLimit++;
      try {

        if (window.location.search) {

          let queryParams = queryString.parse(window.location.search)
          let razorpay_payment_link_reference_id = queryParams.razorpay_payment_link_reference_id;

          console.log('razorpay_payment_link_reference_id =============>', razorpay_payment_link_reference_id);

          // GET PAYMENT STATUS

          const { result: getPaymentStatus } = await apiCall('REACT_APP_GET_PAYMENT_STATUS', 'POST', {
            reference_id: razorpay_payment_link_reference_id,
          })

          if (getPaymentStatus && getPaymentStatus['success'] && getPaymentStatus['status']) {
            this.setState({ paymentInfo: getPaymentStatus['status'] })
          }

          this.setState({ getStatus: true });

        } else {
          window.location.href = '/'
        }

      } catch (error) {
        console.log('Home componentDidMount Error ::', error);
      }
      setTimeout(() => {
        mountLimit = 1;
      }, 500);
    }
  }

  renderSuccess = () => {
    return (
      <React.Fragment>
        <center>
          <div>
            <CheckCircleIcon sx={{ mt: 12, fontSize: 100, color: "green" }} />
            <h1 className='mt-2'>
              Payment SuccessFull
            </h1>
            <p>Amount : <span>{(this.state.paymentInfo.amount_paid) / 100} rs</span></p>
            <p>reference_id : <span>{(this.state.paymentInfo.reference_id)}</span></p>
          </div>
          <Link className='view-orders'
            to={"/orders"}
          >
            <Button className='btn-loadmore'>View Orders</Button>
          </Link>
        </center>
      </React.Fragment>
    )
  }

  renderFailed = () => {
    return (
      <React.Fragment>
        <center>
          <div>
            <CancelIcon sx={{ mt: 9, fontSize: 100, color: "red" }} />
            <h1>
              Payment Failed
            </h1>
            <p>Amount : <span>{(this.state.paymentInfo.amount_paid) / 100} rs</span></p>
            <p>reference_id : <span>{(this.state.paymentInfo.reference_id)}</span></p>
            <h5>Amount will be refunded within 7 to 8 working days</h5>
          </div>
          <Link className='view-orders'
            to={"/orders"}
          >
            <Button className='btn-loadmore'>View Orders</Button>
          </Link>
        </center>
      </React.Fragment>
    )
  }

  renderWait = () => {
    return (
      <React.Fragment>
        <center>
          <div>
            <h1>
              Getting Payment Status, Please Wait .....
            </h1>
          </div>
          <Link className='view-orders'
            to={"/orders"}
          >
            <Button className='btn-loadmore'>View Orders</Button>
          </Link>
        </center>
      </React.Fragment>
    )
  }


  render() {

    return (
      <React.Fragment>
        <div id="mainNumbersContainer">

          {/* render Header Nav Bar */}
          <HeaderNav activeTabName="orders" />

          <div id="subMainContainer" style={{ flexDirection: 'column' }}>

            {
              this.state.getStatus
                ? this.state.paymentInfo && this.state.paymentInfo.status && this.state.paymentInfo.status === "paid"
                  ? this.renderSuccess()
                  : this.renderFailed()
                : this.renderWait()
            }

          </div>

        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return { state }
}

export default connect(mapStateToProps, { cartInfo })(OrderStatus);